<template>
    <div>

        <rkm-list
            :items="data.form.historicoErpsaude"
            @collapse-show="load"
            hide-filters
            hide-pagination
        >
            <template v-slot="{item}">
                <rkm-row>

                    <rkm-col class="flex-grow-1">
                        <rkm-row>
                            <rkm-col cols="2">
                                <item
                                    :get-value="() => `${item.dataAtendimento} às ${item.horarioAtendimento}`"
                                    label="Data"
                                />
                            </rkm-col>

                            <rkm-col>
                                <item
                                    :get-value="() => `${item.unidadeAtendimento}`"
                                    label="Unidade"
                                />
                            </rkm-col>

                            <rkm-col>
                                <item
                                    :get-value="() => `${item.profissional}`"
                                    label="Profissional"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:collapse="{item}">
                <rkm-row
                    class="p-2"
                >
                    <rkm-col cols="12">
                        <template>

                            <BoxAtendimento
                                :item="item.dados"
                            />
                        </template>
                    </rkm-col>
                </rkm-row>
            </template>
        </rkm-list>

        <ModalImpressao
            ref="ModalImpressao"
        />
    </div>
</template>

<script>
// Components.
import BoxAtendimento from './components/atendimento/Index'
import Item from './components/item/Index'
import ModalImpressao from '@/components/ambulatorio/components/impressao/Modal'

// Mixins.
import {error, file, repository} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        BoxAtendimento,
        Item,
        ModalImpressao
    },
    created() {
        this.repositories = {
            atendimento: this.getConectaSusRepository('ambulatorio.atendimento'),
            pdf: this.getConectaSusRepository('impressao.ambulatorio'),
            prontoAtendimentoPdf: this.getConectaSusRepository('impressao.prontoAtendimento'),
            atencaoBasicaPdf: this.getConectaSusRepository('impressao.atencaoBasica'),
            visitaDomiciliar: this.getConectaSusRepository('atencaoBasica.visitaDomiciliar'),
        }
    },
    props: {
        data: {type: Object, required: true},
    },
    computed: {
        handleDisabledAtribuidos() {

            const atribuidos = this.data.form.historico.filter(item => item.selecionado)

            return atribuidos.length === 0 ? true : false
        },
    },
    data: ()  => ({
        flg_processando : 0,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load(item) {

            if (!('dados' in item)) {

                this.setLoading()

                this.repositories.atendimento.getHistoricoAtendimentoHospital(item.id)
                    .then(({data}) => this.$set(item, 'dados', data))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        getUrlHistoricoConectaSUSV1() {
            this.setLoading()

            this.repositories.atendimento.getUrlHistoricoConectaSUSV1(this.data.form.paciente.prontuario)
                .then(response => window.open(response.data.url, '_blank'))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getAmbulatorioTipoLabel(item) {

            if (item.tipo === 'atendimento') {

                return item.isAtendimentoEnfermagem ? 'Atendimento de enfermagem': 'Atendimento'
            }
            else if (item.tipo === 'pos-consulta') {

                return 'Pós-consulta'
            }

            return 'Pré-atendimento'
        },
        openModalImpressao(event, item) {

            event.stopPropagation();

            this.$refs.ModalImpressao.open(item.tipo, item.atendimentoId)
        },
        unlockLoading() {
            this.flg_processando = 0
            this.unsetLoading()
        },
        printFaaEletronica(event, item) {
            if(this.flg_processando == 1){
                 return
            }
            this.flg_processando = 1

            event.stopPropagation();

            this.setLoading()

            this.repositories.prontoAtendimentoPdf.faa.eletronica(item.id)
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unlockLoading())
        },
        printVisitaDomiciliar(event, item) {

            event.stopPropagation();

            this.setLoading()

            this.repositories.atencaoBasicaPdf.fichaVisitaDomiciliar(item.id)
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        print() {

            this.data.form.historico
                .filter(item => item.selecionado)
                .map(item => {
                    this.setLoading()

                    let request = null;

                    if (item.origem === 'ambulatorio') {

                        request = item.tipo === 'atendimento'
                            ? this.repositories.pdf.atendimento(item.atendimentoId)
                            : (item.tipo === 'pos-consulta'
                                ? this.repositories.pdf.posConsulta(item.atendimentoId)
                                : this.repositories.pdf.preAtendimento(item.atendimentoId)
                            )
                    }
                    else if (item.origem === 'pronto-atendimento') {

                        request = this.repositories.prontoAtendimentoPdf.faa.eletronica(item.id)
                    }
                    else if (item.origem === 'atencao-basica-visita-domiciliar') {

                        request = this.repositories.atencaoBasicaPdf.fichaVisitaDomiciliar(item.id)
                    }

                    request
                        .then(({data, headers}) => this.openFile(data, headers['content-type']))
                        .catch(this.handleError)
                        .finally(() => this.unlockLoading())
                })
        },
        selecionarTodos(){

            if(this.handleDisabledAtribuidos){

                this.data.form.historico.filter(item => !item.comSigilo).map(item => (item.selecionado = true))
            } else {

                this.data.form.historico.filter(item => !item.comSigilo).map(item => (item.selecionado = false))
            }
        },
    },
    mixins: [error, file, repository]
}
</script>